export default __webpack_public_path__ + "static/media/AE6.3da3f1c4.jpg";